import BackupCode from '../../components/BackupCode'

const BackupPage = () => {
  return (
    <BackupCode />
  )
}

export default BackupPage